import {Fragment, useEffect, useState} from 'react';
import createOrganisation from "../utils/organisation";

const Organisation = ({ state, updateState, nextStep, previousStep, addToStore }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const companyInformation = state.data.company_information;

  useEffect(() => {
    if (state.data.company_details.company_type !== 'ltd-company') {
      previousStep();
    }
  }, [state, previousStep]);

  const submit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const companyID = await createOrganisation(state);

    addToStore('company_id', companyID);

    nextStep();
  };

  return (
    <Fragment>
      <form action="#" method="POST" onSubmit={(e) => submit(e)}>

      <h1 className="text-2xl font-semibold mb-6">Confirm Business Address</h1>

        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">

          <div className="sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
             Address Line 1
            </label>
            <div className="mt-2.5">
              <p>{ companyInformation.address_1 }</p>
            </div>
          </div>

          <div className="sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Address Line 2
            </label>
            <div className="mt-2.5">
              <p>{ companyInformation.address_2 }</p>
            </div>
          </div>

          <div className="sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Locality
            </label>
            <div className="mt-2.5">
              <p>{ companyInformation.locality }</p>
            </div>
          </div>

          <div className="sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Postal Code
            </label>
            <div className="mt-2.5">
              <p>{ companyInformation.postal_code }</p>
            </div>
          </div>

          <div className="sm:col-span-2">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Country
            </label>
            <div className="mt-2.5">
              <p>{ companyInformation.country }</p>
            </div>
          </div>

        </div>

        <div className="mt-12">
          <button type="submit"
                  disabled={isSubmitting}
                  className="bg-purple-800 disabled:bg-purple-200 hover:bg-purple-900 text-white font-semibold rounded-md py-2 px-4 w-full">
            { isSubmitting && (
              <Fragment>
                <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-3 text-white animate-spin"
                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"/>
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"/>
                </svg>
              </Fragment>
            )}
            { !isSubmitting && (
              <Fragment>
                This is Correct
              </Fragment>
            )}
          </button>
        </div>

        <div className="mt-4">
          <button type="button"
                  onClick={previousStep}
                  disabled={isSubmitting}
                  className="block w-full rounded-md bg-slate-300 px-3.5 py-2.5 text-center text-md font-semibold text-black shadow-sm hover:text-white hover:bg-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-600">
            Try Again
          </button>
        </div>
      </form>
    </Fragment>
  );
}

export default Organisation;
